import { useState } from "react";
import { Smile, Send, ChevronDown, ChevronRight, X } from "lucide-react";
import { resumoDevidos, CICLO_DIAS } from "../lib/pesquisa";
import { fmtShort } from "../utils";

// ═══════════════════════════════════════════════════════════════
// BANNER DE PESQUISA — a régua de 3 meses na cara da gerência
// ═══════════════════════════════════════════════════════════════
//
// Parceiro ativo não reclama até ir embora. Este banner existe para a conversa
// acontecer antes disso, e aparece só para gerente e administrador: pesquisa
// de satisfação é relacionamento, não tarefa de prospecção.
//
// Ele some quando não há ninguém vencido. Não trava nada, não abre sozinho em
// cima do trabalho — fica no topo do painel, e some quando o time põe em dia.

export default function BannerPesquisa({ partners = [], satisfaction = [], hoje, role = "comercial", onEnviar }) {
  const [aberto, setAberto] = useState(false);
  const [fechado, setFechado] = useState(false);
  const gerencial = role === "gerente" || role === "admin";

  const r = resumoDevidos(partners, satisfaction, hoje);
  if (!gerencial || fechado || r.total === 0) return null;

  return (
    <div style={{ background: "#fff", borderRadius: 10, border: "1px solid #bae6fd", borderLeft: "4px solid #0284c7", padding: "12px 14px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <Smile size={16} color="#0284c7" />
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 12.5, fontWeight: 700, color: "#0f172a" }}>
            {r.total} {r.total === 1 ? "parceiro ativo está" : "parceiros ativos estão"} sem pesquisa há mais de {CICLO_DIAS} dias
          </div>
          <div style={{ fontSize: 10.5, color: "#64748b" }}>
            {r.nunca > 0 && <>{r.nunca} {r.nunca === 1 ? "nunca respondeu" : "nunca responderam"}. </>}
            {r.maisAntigo && <>O mais antigo está há {r.maisAntigo.dias} dias sem ser ouvido.</>}
          </div>
        </div>
        <button onClick={() => setAberto((v) => !v)} style={{ display: "flex", alignItems: "center", gap: 4, padding: "5px 10px", borderRadius: 6, border: "1px solid #e2e8f0", background: "#fff", color: "#475569", fontSize: 11, fontWeight: 600, cursor: "pointer" }}>
          {aberto ? <ChevronDown size={12} /> : <ChevronRight size={12} />} Ver quem
        </button>
        <button onClick={onEnviar} style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 13px", borderRadius: 7, border: "none", background: "#0284c7", color: "#fff", fontSize: 11.5, fontWeight: 600, cursor: "pointer" }}>
          <Send size={12} /> Enviar pesquisa
        </button>
        <button onClick={() => setFechado(true)} aria-label="Fechar" style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", display: "flex", padding: 2 }}>
          <X size={14} />
        </button>
      </div>

      {aberto && (
        <div style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid #f1f5f9", maxHeight: 220, overflow: "auto" }}>
          {r.lista.slice(0, 30).map((d) => (
            <div key={d.parceiro.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, padding: "5px 0", borderBottom: "1px solid #f8fafc", fontSize: 11.5 }}>
              <span style={{ color: "#334155", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {d.parceiro.name}
                {d.parceiro.cidade ? <span style={{ color: "#94a3b8" }}> · {d.parceiro.cidade}</span> : null}
              </span>
              <span style={{ color: "#64748b", whiteSpace: "nowrap" }}>
                {d.ultima
                  ? <>última em {fmtShort(d.desde)}{d.nota != null ? ` · nota ${d.nota}` : ""}</>
                  : <span style={{ color: "#b45309" }}>nunca respondeu · ativo desde {fmtShort(d.desde)}</span>}
              </span>
            </div>
          ))}
          {r.lista.length > 30 && (
            <div style={{ fontSize: 10.5, color: "#94a3b8", paddingTop: 6 }}>e mais {r.lista.length - 30}…</div>
          )}
        </div>
      )}
    </div>
  );
}
